var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.618 60.618",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.147,47.552l3,3H12.054c-4.272,0-7.746-3.475-7.746-7.746V18.682c0-1.938,0.72-3.708,1.901-5.068l2.139,2.139 c-0.641,0.81-1.04,1.819-1.04,2.929v2.235h6.204l8.27,8.27H7.308v13.619c0,2.617,2.129,4.746,4.746,4.746H40.147z M52.872,50.552 h-0.069l6.074,6.074c0.781,0.781,0.781,2.047,0,2.828c-0.391,0.391-0.902,0.586-1.414,0.586s-1.023-0.195-1.414-0.586L0.586,3.992 c-0.781-0.781-0.781-2.047,0-2.828c0.781-0.781,2.047-0.781,2.828,0l9.772,9.771h39.686c4.271,0,7.746,3.476,7.746,7.747v24.124 C60.618,47.078,57.144,50.552,52.872,50.552z M16.186,13.935l6.983,6.982h34.45v-2.235c0-2.617-2.129-4.747-4.746-4.747H16.186z  M49.804,47.552h3.069c2.617,0,4.746-2.129,4.746-4.746V29.187h-26.18L49.804,47.552z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCreditCard);
export default __webpack_public_path__ + "static/media/no-credit-card.3b78f67d8448163ff7d2e27cc52f516e.svg";
export { ForwardRef as ReactComponent };